/**
 * Tutorial guidato delle impostazioni AI / Social.
 *
 * Un preparativo solo: il riquadro del primo servizio, che il passo dedicato apre
 * per mostrarne i campi. `stopAiSocialTour` lo richiude a fine giro, e solo se ad
 * aprirlo e' stato il tutorial. Gli interruttori non si toccano: salvano subito.
 */
const SCOPE = '[data-tour-scope="setting-ai-social"]';

const at = name => `${SCOPE} [data-tour="${name}"]`;

let opened = false;

const visible = selector => {
	const element = document.querySelector(selector);

	return !!element && element.getClientRects().length > 0;
};

/** Apre il riquadro del primo servizio, se non e' gia' aperto. */
function openFirst() {
	if (visible(at('settings'))) return;

	const toggle = document.querySelector(at('expand'));

	if (toggle) {
		opened = true;
		toggle.click();
	}
}

/** Richiude il riquadro aperto dal tutorial. */
export function stopAiSocialTour() {
	if (!opened) return;

	opened = false;

	if (visible(at('settings'))) {
		document.querySelector(at('expand'))?.click();
	}
}

export function createAiSocialTourSteps() {
	return [
		{
			body: "Questa pagina tiene insieme due cose che il gestionale usa spesso: l'intelligenza artificiale, che scrive le descrizioni dei prodotti e gli articoli del blog, e i profili social su cui pubblicare.",
			key: 'intro',
			placement: 'bottom',
			target: at('tutorial'),
			title: 'Intelligenza artificiale e social',
		},
		{
			body: "Una riga per servizio con il suo interruttore, che salva subito. OpenAI e' quello che vale la pena accendere per primo: senza, le funzioni che scrivono testi restano mute - il blog, per esempio, risponde che non e' configurato.",
			key: 'table',
			placement: 'top',
			target: at('table'),
			title: 'Accendere un servizio',
		},
		{
			body: "Il piu' a inizio riga apre la configurazione. Per OpenAI serve la chiave API, che si genera dal proprio account e si paga a consumo; per Facebook e Instagram servono gli identificativi della pagina e del profilo aziendale, che arrivano dalla console di Meta.",
			before: stopAiSocialTour,
			key: 'expand',
			placement: 'right',
			target: at('expand'),
			timeout: 400,
			title: 'Aprire la configurazione',
		},
		{
			body: "I campi si compilano con quello che il servizio ha rilasciato e si confermano qui dentro. Una chiave API e' come una password che costa: chi ce l'ha puo' spendere sul tuo account, quindi non va girata via chat ne' lasciata in giro.",
			before: openFirst,
			key: 'settings',
			placement: 'right',
			target: at('settings'),
			timeout: 600,
			title: 'Le chiavi di accesso',
		},
	];
}
